module.exports = __webpack_public_path__ + "img/cb9-r-000.53b6e72c.gif";